import Loading from "../../components/Loading/Loading";

import { useQuery } from "@tanstack/react-query";
import {
  ChangeMapAvailability,
  GetMapAvailability,
} from "../../services/services";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";
import { useEffect, useState } from "react";

const Services = () => {
  const [mapAvailability, setMapAvailability] = useState(null);
  const { data: getMapAvailability } = useQuery({
    queryKey: ["GetMapAvailability"],
    queryFn: () => GetMapAvailability(),
    select: (res) => res,
    retry: false,
    enabled: true,
  });
  useEffect(() => {
    if (getMapAvailability === true || getMapAvailability === false) {
      setMapAvailability(getMapAvailability);
    }
  }, [getMapAvailability]);

  const Options = [
    { label: "فعال", value: true },
    { label: "غیرفعال", value: false },
  ];
  return (
    <div className={"League"}>
      {mapAvailability === null && <Loading />}
      <h4>تنظیمات اپلیکیشن خانه ستارگان</h4>
      <div style={{ gap: "12px", marginTop: "12px" }} className="row ">
        <div className="col-5 card">
          <div className="background-dataTable">
            <h6> نقشه خانه ستارگان </h6>
            <SelectCustom
              name="mapAvailability"
              isClearable={true}
              isSearchable={false}
              unstyled={true}
              options={Options}
              value={
                Options.find((item) => item.value == mapAvailability) || null
              }
              onChange={(e) => {
                setMapAvailability(e.value);
              }}
            />
            <button
              style={{
                color: "#ffffff",
                background: "#86a0ff",
                border: 0,
                width: "68px",
                borderRadius: "8px",
                padding: "4px 0",
                marginTop: "20px",
              }}
              onClick={() =>
                ChangeMapAvailability({ hasInternet: mapAvailability })
              }
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
